export const settings = [
  {
    label: "Background",
    selector: "background",
    type: "background-image",
    value:
      "url(https://embed.filekitcdn.com/e/ob1LxuDzufvKjqSohJyaUP/5oPVzNSoHca4JJZz2kaMCf)"
  },
  {
    label: "Form background",
    selector: "form",
    type: "background-color",
    value: "#ffffff"
  },
  {
    label: "Border radius",
    selector: "form",
    type: "border-radius",
    value: 10
  },
  {
    group: "header",
    selector: "header",
    type: "color",
    value: "#3d3d3d"
  },
  {
    group: "header",
    selector: "header",
    type: "font-weight",
    value: 700
  },
  {
    group: "content",
    selector: "content",
    type: "color",
    value: "#6e6e6e"
  },
  {
    group: "field",
    selector: "field",
    type: "color",
    value: "#6e6e6e"
  },
  {
    group: "field",
    selector: "field",
    type: "background-color",
    value: "#f7f7f7"
  },
  {
    group: "field",
    selector: "field",
    type: "border-radius",
    value: 5
  },
  {
    group: "field",
    selector: "field",
    type: "font-weight",
    value: 400
  },
  {
    group: "button",
    selector: "button",
    type: "color",
    value: "#ffffff"
  },
  {
    group: "button",
    selector: "button",
    type: "background-color",
    value: "#785EDF"
  },
  {
    group: "button",
    selector: "button",
    type: "border-radius",
    value: 5
  },
  {
    group: "button",
    selector: "button",
    type: "font-weight",
    value: 700
  },
  {
    group: "disclaimer",
    selector: "disclaimer",
    type: "color",
    value: "#6e6e6e"
  }
]
